import "core-js/modules/es6.function.name";
import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var Vendor =
/*#__PURE__*/
function (_BaseData) {
  _inherits(Vendor, _BaseData);

  function Vendor() {
    _classCallCheck(this, Vendor);

    return _possibleConstructorReturn(this, _getPrototypeOf(Vendor).call(this, "Vendor"));
  }

  _createClass(Vendor, [{
    key: "Search",
    value: function () {
      var _Search = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(search, newVendorIds) {
        var vendorSearch;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vendorSearch = {
                  search: search,
                  newVendorIds: newVendorIds
                };
                return _context.abrupt("return", axios.post("/api/".concat(this._controller, "/Search"), vendorSearch));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function Search(_x, _x2) {
        return _Search.apply(this, arguments);
      }

      return Search;
    }()
  }, {
    key: "SearchAddress",
    value: function () {
      var _SearchAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(searchAddress) {
        var vendorSearch;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                vendorSearch = {
                  address: searchAddress.address,
                  city: searchAddress.city,
                  state: searchAddress.state,
                  zip: searchAddress.zip,
                  name: searchAddress.name
                };
                return _context2.abrupt("return", axios.post("/api/".concat(this._controller, "/SearchAddress"), vendorSearch));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function SearchAddress(_x3) {
        return _SearchAddress.apply(this, arguments);
      }

      return SearchAddress;
    }()
  }, {
    key: "GetActive",
    value: function () {
      var _GetActive = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(HasW9) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetActive/").concat(HasW9)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetActive(_x4) {
        return _GetActive.apply(this, arguments);
      }

      return GetActive;
    }()
  }, {
    key: "ImportList",
    value: function () {
      var _ImportList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(NewVendors) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.post("/api/".concat(this._controller, "/ImportList"), NewVendors));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function ImportList(_x5) {
        return _ImportList.apply(this, arguments);
      }

      return ImportList;
    }()
  }, {
    key: "GetVendorByAlphaSearch",
    value: function () {
      var _GetVendorByAlphaSearch = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(value, HasW9) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/GetVendorByAlphaSearch/").concat(value, "/").concat(HasW9)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetVendorByAlphaSearch(_x6, _x7) {
        return _GetVendorByAlphaSearch.apply(this, arguments);
      }

      return GetVendorByAlphaSearch;
    }()
  }]);

  return Vendor;
}(BaseData);

export default new Vendor();